module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page photosets */

(function(fox) {

	fox.registerWidget('SitePage_Photosets', {}, 'Site_Page');
	
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/photosets.js
// module id = 908
// module chunks = 4